<section class="LCS_login-container">
    <img src="assets/img/login-top-img.svg" alt="" class="LCS_top-img">
    <img src="assets/img/login-bottom-img.svg" alt="" class="LCS_bottom-img">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-md-6 LCS_left-sec">
          <h1>Welcome to<br><span>LIVE CLASS<br>TEACHER PLATFORM</span></h1>
          <div class="LCS_login-form-holder">
            <div class="form-group">
              <!-- <input type="text" class="form-control" placeholder="Enter your mobile number">
              <button type="button" class="btn btn-primary">Start teaching</button> -->
                <form method="POST">
                  <app-common-mobile-number id="StartLearningMobileInput" (mobileNumberChange)="doSearch($event)"
                    (keyup.enter)="enterKey($event, 1)" (keyup.escape)="escapeKey($event)" (callSignUp)="signup(1)">
                  </app-common-mobile-number>
                </form>
            
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <img src="assets/img/login-illustration.svg" alt="" class="LCS_main-img">
        </div>
      </div>
    </div>
  </section>